// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73b64f5e","239":"bb1ac5ff","455":"13afc6f1"}[chunkId] + ".chunk.js";
};